import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import HelpIcon from '@mui/icons-material/Help';

import {createUseStyles} from 'react-jss'
import { Typography } from '@mui/material';

const useStyles = createUseStyles({
    root: {
        display: 'flex'
        ,flexDirection: 'row'
        ,alignItems: 'center'
        ,justifyContent: 'center'
        ,height: '50px'
        ,minWidth: '150px'
    }
    ,textDialog: {
        width: '100%'
        ,padding: 5
        ,fontSize: '14'
    }
    ,iconDialog: {
        width: '54px'
        ,padding: 5
    }
});

export default function DialogConfirm(props) {

    const classes = useStyles();

    return (
        <Dialog open={props.open}>
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent dividers className={classes.root}>
                <Typography className={classes.iconDialog} style={{color: 'blue'}}>
                    <HelpIcon fontSize="large" />
                </Typography>
                <DialogContentText>
                    {props.textDialog}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onConfirm}>{props.textBtnConfirmar}</Button>
                <Button onClick={props.onCancel}>{props.textBtnCancelar}</Button>
            </DialogActions>
        </Dialog>
    )
}

DialogConfirm.defaultProps = {
    open: false
    ,title: 'Confirmar'
    ,textDialog: 'Confirme'
    ,onConfirm: () => {}
    ,onCancel: () => {}
    ,textBtnConfirmar : "Confirmar"
    ,textBtnCancelar : "Cancelar"
}